"use client";
import Ticker from "@/components/Ticker";
import Image from "next/image";

const Intro = () => {
  return (
    <div>
      <section className="py-10 md:py-20  bg-gray-900">
        <div className="max-w-screen-lg mx-5 lg:mx-auto">
          <div className="grid lg:flex justify-between gap-5 md:gap-14">
            <div className="text-lg md:text-base text-left md:w-2/6">
              <p className="text-white text-3xl font-semibold leading-10">
                At FHM Events, we don’t just manage events – we solve problems.
              </p>
            </div>
            <div className=" md:w-3/4">
              <p>
                <p className="text-white text-xl leading-8">
                  Our team brings together expertise from diverse backgrounds
                  including travel logistics, event planning, marketing, and
                  technology. This unique blend allows us to see challenges from
                  multiple angles and craft innovative solutions.
                </p>
              </p>
            </div>
          </div>
        </div>
        <section className=" mt-12 mx-5">
          <div className="max-w-screen- mx-auto text-center p-5">
            <Ticker />
          </div>
        </section>
      </section>
      <section className="relative py-40 md:py-40 lg:py-72 -z-20 before:-z-10 ">
        <Image
          src="/images/gallery-2.jpg"
          alt="Background Image"
          fill
          className="absolute top-0 left-0 w-full h-full -z-10 object-cover"
        />

        <div className="absolute inset-0  z-0"></div>
      </section>
      <section className="py-16">
        <div className="max-w-screen-xl mx-auto ">
          <div className="">
            <Image
              alt="At FHM Events, Our Services"
              src="/images/digram.png"
              className=" object-cover mx-auto"
              width={1400}
              height={573}
            />
          </div>
        </div>
      </section>
      {/* <section className="max-w-screen-2xl mx-auto py-16 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-3 lg;grid-cols-3 gap-3 items-center py-10 justify-between ">
          <div>
            <div>
              <div className="-mt-20 float-left lg:float-right">
                <img
                  src="/images/light-com.svg"
                  alt="Retail Branding Icon"
                  className="w-16 h-16 mb-4 bg-[#27AAE0] p-3 rounded-full"
                />
              </div>
              <p className="text-xl font-bold mb-4 text-left lg:text-right uppercase text-[#27AAE0]">
                Meetings that Inspire
              </p>
              <p className="text-left lg:text-right lg:pl-24">
                Our meetings are designed to spark new ideas and foster
                engagement. With years of experience managing corporate
                meetings, FHM guarantees flawless execution.
              </p>
            </div>
            <div className="">
              <div className=" float-left lg:float-right -mt-20 ">
                <img
                  src="/images/eye-com.svg"
                  alt="Retail Branding Icon"
                  className="w-16 h-16 mb-4 bg-[#0E49A3] p-3 rounded-full"
                />
              </div>
              <p className="text-xl font-bold mb-4 text-left lg:text-right uppercase text-[#0E49A3]">
                Exhibitions that Impress
              </p>
              <p className="text-left lg:text-right lg:pl-24">
                FHM’s exhibitions are designed to capture attention and
                engage audiences. Our expertise ensures your brand is positioned
                to make a lasting impact.
              </p>
            </div>
          </div>
          <div className="self-center">
            <Image
              alt=""
              src="/images/circel.png"
              className=" mx-auto w-full h-auto"
              width={1400}
              height={573}
            />
          </div>
          <div>
            <div>
              <img
                src="/images/handshake.svg"
                alt="Retail Branding Icon"
                className="w-16 h-16 mb-4 bg-[#10A2EF] p-3 rounded-full"
              />
              <p className="text-xl font-bold mb-4 text-left uppercase text-[#10A2EF]">
                Incentives that Motivate
              </p>
              <p className="text-left pr-24">
                FHM creates incentive programs that motivate and inspire
                teams. From luxury retreats to team-building activities, our
                incentives drive peak performance and engagement.
              </p>
            </div>
            <div>
              <img
                src="/images/meeting-com.svg"
                alt="Retail Branding Icon"
                className="w-16 h-16 mb-4 bg-[#1F76D0] p-3 rounded-full"
              />
              <p className="text-xl font-bold mb-4 text-left uppercase text-[#1F76D0]">
                Conferences that Connect
              </p>
              <p className="text-left pr-24">
                Our conferences are designed to connect people and ideas. With
                experience hosting over 500 attendees, FHM ensures seamless
                logistics and engaging experiences.
              </p>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default Intro;
